// @ts-nocheck
import React, { useContext, useEffect, useMemo, useReducer, useState } from "react";
import { Collapse } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { useI18n } from "../../../context/I18nContext";
import { useDispatch, useSelector } from "react-redux";
import { navClose } from "../../../store/actions/AuthActions";
import { useMessageNotification } from "../../../context/MessageNotificationContext";
import { useMenuFilter } from "./useMenuFilter";
import { branding } from "../../../config/branding";
import { SidebarResizer, SidebarToggle } from "./SidebarControls";
import SidebarMenuSearch from "./SidebarMenuSearch";
import { filterMenuBySearch } from "./menu-search";
import { resolveMenuPath } from "./menu-trail";
import { menuItemTourId } from "../../../shared/onboarding/menu-tour-target";

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
}

const resolveEventScopedPath = (routePath) => {
  return routePath;
};

const getMenuPathKey = (value) => {
  if (!value) return '';
  return String(value).split('?')[0].split('#')[0].replace(/^\//, '');
};

const SideBar = () => {
  const { t } = useI18n();
  const { unreadCount } = useMessageNotification();
  const {
    iconHover,
    sidebarposition,
    headerposition,
    sidebarLayout,
    ChangeIconSidebar,
  } = useContext(ThemeContext);
  const logoSrc = branding.logoUrl;
  const sidebarIconLightColor = "rgba(59, 130, 246, 0.65)";
  const date = new Date();
  const dispatch = useDispatch();
  const sideMenu = useSelector((state) => state.sideMenu);
  const { visibleMenuList, isEventAdminSession } = useMenuFilter();
  const [menuSearch, setMenuSearch] = useState("");
  const isSearching = menuSearch.trim().length > 0;
  const displayedMenuList = useMemo(
    () => filterMenuBySearch(visibleMenuList, menuSearch, t),
    [visibleMenuList, menuSearch, t],
  );

  const [state, setState] = useReducer(reducer, initialState);
  const handleMenuActive = status => {
    setState({ active: status });
    if (state.active === status) {
      setState({ active: "" });
    }
  }
  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: status })
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: "" })
    }
  }
  const closeSidebarOnMobile = () => {
    if (typeof window === "undefined") return;
    const isTabletOrMobile = window.matchMedia("(max-width: 1299.98px)").matches;
    if (isTabletOrMobile && sideMenu) {
      const wrapper = document.getElementById("main-wrapper");
      if (wrapper) {
        wrapper.classList.remove("menu-toggle");
      }
      dispatch(navClose());
    }
  };

  const handleMenuLinkClick = (event) => {
    setMenuSearch("");
    closeSidebarOnMobile();
    event.currentTarget.blur();
  };

  //For scroll
  const [hideOnScroll, setHideOnScroll] = useState(true)
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y
      if (isShow !== hideOnScroll) setHideOnScroll(isShow)
    },
    [hideOnScroll]
  )

  const resolveMenuTitle = (title) => {
    if (title === "menu.b2bAdminSection") {
      return isEventAdminSession ? "B2B YÖNETİCİ" : "B2B ADMIN";
    }
    return t(title);
  };
  // Detay sayfalarinda (ornegin /meetings/123) menudeki ust sayfa secili gorunur.
  const path = resolveMenuPath(getMenuPathKey(window.location.pathname)).menuPath;

  useEffect(() => {
    let foundActive = '';
    let foundSubmenu = '';
    visibleMenuList.forEach((data) => {
      data.content?.forEach((item) => {
        if (path === getMenuPathKey(item.to)) {
          foundActive = data.title;
        }
        if (item.to && path.startsWith(`${getMenuPathKey(item.to)}/`)) {
          foundActive = data.title;
        }
        item.content?.forEach(ele => {
          if (path === getMenuPathKey(ele.to)) {
            foundSubmenu = item.title;
            foundActive = data.title;
          }
          if (ele.to && path.startsWith(`${getMenuPathKey(ele.to)}/`)) {
            foundSubmenu = item.title;
            foundActive = data.title;
          }
        });
      });
    });
    setState({ active: foundActive, activeSubmenu: foundSubmenu });
  }, [path, visibleMenuList]);
  return (
    <>
      <div className="sidebar-backdrop" onClick={closeSidebarOnMobile} />
      <div
        onMouseEnter={() => ChangeIconSidebar(true)}
        onMouseLeave={() => ChangeIconSidebar(false)}
        className={`deznav web-user-sidebar ${iconHover} ${sidebarposition.value === "fixed" &&
          sidebarLayout.value === "horizontal" &&
          headerposition.value === "static"
          ? hideOnScroll > 120
            ? "fixed"
            : ""
          : ""
          }`}
      >
        <style>{`
        .deznav .metismenu li.mm-active > a > i,
        .deznav .metismenu li > a.mm-active > i,
        .deznav .metismenu li.mm-active > a .me-2 > i,
        .deznav .metismenu li > a.mm-active .me-2 > i,
        .deznav .metismenu li > a[aria-expanded="true"] > i {
          display: inline-block !important;
          opacity: 1 !important;
          visibility: visible !important;
        }

        [data-sidebar-style="mini"][data-layout="vertical"] .deznav {
          height: calc(100vh - 5.5rem) !important;
        }

        [data-sidebar-style="mini"][data-layout="vertical"] .deznav-scroll,
        [data-sidebar-style="mini"][data-layout="vertical"] .slimScrollDiv {
          max-height: calc(100vh - 5.5rem) !important;
          overflow-y: auto !important;
          overflow-x: visible !important;
        }

        @media (max-width: 1299.98px) {
          [data-sidebar-style="mini"][data-layout="vertical"] .deznav {
            top: 4.5rem !important;
            height: calc(100vh - 4.5rem) !important;
          }

          [data-sidebar-style="mini"][data-layout="vertical"] .deznav-scroll,
          [data-sidebar-style="mini"][data-layout="vertical"] .slimScrollDiv {
            max-height: calc(100vh - 4.5rem) !important;
          }
        }

        @media (max-width: 767.98px) {
          [data-sidebar-style="mini"][data-layout="vertical"] .deznav {
            top: 5rem !important;
            height: calc(100vh - 5rem) !important;
          }

          [data-sidebar-style="mini"][data-layout="vertical"] .deznav-scroll,
          [data-sidebar-style="mini"][data-layout="vertical"] .slimScrollDiv {
            max-height: calc(100vh - 5rem) !important;
          }
        }

        .web-user-sidebar .metismenu > li > a .sidebar-menu-label {
          display: block;
          min-width: 0;
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 14px;
          font-weight: 500;
          line-height: 1.2;
          letter-spacing: 0;
        }

        .web-user-sidebar .metismenu > li.mm-active > a .sidebar-menu-label {
          font-weight: 700;
        }

        /* Uzun alt menu adlari "..." ile kesilmez, ikinci satira iner. */
        .web-user-sidebar .metismenu .sidebar-submenu-label {
          display: block;
          min-width: 0;
          max-width: 100%;
          white-space: normal;
          overflow-wrap: anywhere;
          font-size: 13px;
          font-weight: 400;
          line-height: 1.3;
          letter-spacing: 0;
        }

        .web-user-sidebar .metismenu li.mm-active > a > .sidebar-submenu-label {
          font-weight: 700;
        }

        .web-user-sidebar .sidebar-badge {
          font-size: 12px;
          font-weight: 700;
          line-height: 1.2;
          letter-spacing: 0;
        }

        .web-user-sidebar .sidebar-footer-brand {
          font-size: 16px;
          font-weight: 700;
          line-height: 1.3;
          letter-spacing: 0;
        }

        .web-user-sidebar .sidebar-footer-copyright {
          font-size: 14px;
          font-weight: 400;
          line-height: 1.5;
          letter-spacing: 0;
        }

        .web-user-sidebar .sidebar-support-text {
          font-size: 16px;
          font-weight: 700;
          line-height: 1.2;
          letter-spacing: 0;
        }

        .web-user-sidebar .mobile-sidebar-brand {
          display: none;
        }

        .web-user-sidebar .nav-text {
          display: inline-flex !important;
          align-items: center !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
          max-width: calc(100% - 28px) !important;
          margin-top: 0 !important;
          overflow: hidden !important;
          text-align: left !important;
        }

        .web-user-sidebar .metismenu > li > a {
          display: flex !important;
          align-items: center !important;
          flex-direction: row !important;
          justify-content: flex-start !important;
          width: 100%;
          text-align: left !important;
        }

        .web-user-sidebar .metismenu > li > a > i {
          display: inline-flex !important;
          flex: 0 0 18px;
          align-items: center;
          justify-content: center;
          margin-right: 10px !important;
        }

        .web-user-sidebar .metismenu > li {
          text-align: left !important;
        }

        [data-sidebar-style="compact"] .web-user-sidebar .metismenu li,
        [data-sidebar-style="mini"] .web-user-sidebar .metismenu li,
        .menu-toggle .web-user-sidebar .metismenu li {
          text-align: left !important;
        }

        [data-sidebar-style="compact"] .web-user-sidebar .metismenu > li > a,
        [data-sidebar-style="mini"] .web-user-sidebar .metismenu > li > a,
        .menu-toggle .web-user-sidebar .metismenu > li > a {
          display: flex !important;
          align-items: center !important;
          flex-direction: row !important;
          justify-content: flex-start !important;
          text-align: left !important;
        }

        [data-sidebar-style="compact"] .web-user-sidebar .metismenu > li > a .nav-text,
        [data-sidebar-style="mini"] .web-user-sidebar .metismenu > li > a .nav-text,
        .menu-toggle .web-user-sidebar .metismenu > li > a .nav-text {
          display: inline-flex !important;
          align-items: center !important;
          flex: 1 1 auto !important;
          margin-top: 0 !important;
        }

        @media (max-width: 1299.98px) {
          [data-sidebar-style="overlay"][data-layout="vertical"] .web-user-sidebar {
            width: min(380px, calc(100vw - 24px)) !important;
            max-width: min(380px, calc(100vw - 24px)) !important;
            top: 0 !important;
            height: 100vh !important;
            overflow: hidden !important;
            border-right: 1px solid rgba(255, 255, 255, 0.12);
            box-shadow: 14px 0 36px rgba(23, 37, 84, 0.28) !important;
          }

          [data-sidebar-style="overlay"][data-layout="vertical"] .web-user-sidebar .mobile-sidebar-brand {
            display: flex;
            align-items: center;
            justify-content: center;
            position: sticky;
            top: 0;
            z-index: 2;
            min-height: 76px;
            padding: 28px 20px 20px;
            margin: 0 0 10px;
            background: linear-gradient(180deg, rgba(30, 58, 138, 0.98) 0%, rgba(30, 58, 138, 0.94) 100%);
            border-bottom: 1px solid rgba(255, 255, 255, 0.08);
            box-shadow: 0 10px 24px rgba(23, 37, 84, 0.18);
          }

          [data-sidebar-style="overlay"][data-layout="vertical"] .web-user-sidebar .mobile-sidebar-brand img {
            display: block;
            width: auto;
            max-width: 180px;
            max-height: 52px;
            height: auto;
            object-fit: contain;
          }

          [data-sidebar-style="overlay"][data-layout="vertical"] .web-user-sidebar .metismenu {
            padding-top: 0;
            padding-bottom: 10px;
          }

          [data-sidebar-style="overlay"][data-layout="vertical"] .web-user-sidebar .metismenu > li {
            margin: 0;
            padding: 0 8px;
          }

          [data-sidebar-style="overlay"][data-layout="vertical"] .web-user-sidebar .metismenu > li > a {
            min-height: 42px;
            border-radius: 12px;
            padding: 8px 28px 8px 12px;
          }

          [data-sidebar-style="overlay"][data-layout="vertical"] .web-user-sidebar .metismenu > li > a > i {
            width: 18px;
            margin-right: 10px;
            font-size: 15px;
            text-align: center;
          }

          [data-sidebar-style="overlay"][data-layout="vertical"] .web-user-sidebar .has-arrow:after {
            right: 12px;
          }

          [data-sidebar-style="overlay"][data-layout="vertical"] .web-user-sidebar .metismenu > li.mm-active > a {
            border-left-width: 3px;
            border-radius: 0 12px 12px 0;
            box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08), 0 10px 22px rgba(23, 37, 84, 0.2);
          }

          [data-sidebar-style="overlay"][data-layout="vertical"] .web-user-sidebar .deznav-scroll,
          [data-sidebar-style="overlay"][data-layout="vertical"] .web-user-sidebar .slimScrollDiv {
            height: 100% !important;
            max-height: 100% !important;
            overflow-y: auto !important;
            overflow-x: hidden !important;
            overscroll-behavior: contain;
          }

          [data-sidebar-style="overlay"][data-layout="vertical"] .web-user-sidebar .metismenu > li > a,
          [data-sidebar-style="overlay"][data-layout="vertical"] .web-user-sidebar .metismenu ul a {
            display: flex;
            align-items: center;
            min-width: 0;
          }

          [data-sidebar-style="overlay"][data-layout="vertical"] .web-user-sidebar .metismenu > li > a > i,
          [data-sidebar-style="overlay"][data-layout="vertical"] .web-user-sidebar .metismenu ul a > .me-2 {
            flex: 0 0 auto;
          }

          [data-sidebar-style="overlay"][data-layout="vertical"] .web-user-sidebar .nav-text,
          [data-sidebar-style="overlay"][data-layout="vertical"] .web-user-sidebar .sidebar-menu-label,
          [data-sidebar-style="overlay"][data-layout="vertical"] .web-user-sidebar .sidebar-submenu-label {
            min-width: 0;
          }

          [data-sidebar-style="overlay"][data-layout="vertical"] .web-user-sidebar .sidebar-menu-label {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          [data-sidebar-style="overlay"][data-layout="vertical"] .web-user-sidebar .metismenu li > ul {
            position: static !important;
            left: auto !important;
            top: auto !important;
            width: 100% !important;
            box-shadow: none !important;
            padding-left: 0 !important;
          }

          [data-sidebar-style="overlay"][data-layout="vertical"] .web-user-sidebar .metismenu li:hover > ul {
            overflow: hidden !important;
          }
        }
      `}</style>


        <SidebarResizer />
        <div className="deznav-scroll">
          <SidebarToggle />
          <div className="mobile-sidebar-brand">
            <img src={logoSrc} alt="B2Meet" />
          </div>
          <SidebarMenuSearch value={menuSearch} onChange={setMenuSearch} />
          <ul className="metismenu" id="menu">
            {isSearching && displayedMenuList.length === 0 ? (
              <li className="wc-menu-search-empty">{t("menuSearch.empty")}</li>
            ) : null}
            {displayedMenuList.map((data, index) => {
              const menuPathKey = getMenuPathKey(data.to);
              let menuClass = data.classsChange;
              if (menuClass === "menu-title") {
                return (
                  <li className={menuClass} key={index} >{resolveMenuTitle(data.title)}</li>
                )
              } else {
                return (
                  <li className={`has-menu ${state.active === data.title ? 'mm-active' : ''}${menuPathKey === path ? 'mm-active' : ''} `}
                    key={index}
                    data-tour={data.content?.length > 0 ? undefined : menuItemTourId(menuPathKey)}
                  >
                    {data.content && data.content.length > 0 ?
                      <>
                        <Link to={"#"}
                          className="has-arrow ai-icon"
                          onClick={() => { handleMenuActive(data.title) }}
                        >
                          {data.iconStyle}{" "}
                          <span className="nav-text">
                            <span className="sidebar-menu-label">{resolveMenuTitle(data.title)}</span>
                            <span className="badge badge-xs style-1 badge-danger ms-2 sidebar-badge">{data.update}</span>
                          </span>
                        </Link>

                        <Collapse in={isSearching || state.active === data.title}>
                          <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""}${data.title === 'menu.b2bPanel' ? ' web-user-b2b-panel-submenu' : ''}`}>
                            {data.content && data.content.map((data, index) => {
                              const submenuPathKey = getMenuPathKey(data.to);
                              return (
                                <li key={index}
                                  className={`${state.activeSubmenu === data.title ? "mm-active" : ""}${submenuPathKey === path ? 'mm-active' : ''}`}
                                  data-tour={menuItemTourId(submenuPathKey)}
                                >
                                  {data.content && data.content.length > 0 ?
                                    <>
                                      <Link to={resolveEventScopedPath(data.to)} className={data.hasMenu ? 'has-arrow' : ''}
                                        onClick={() => { handleSubmenuActive(data.title) }}
                                      >
                                        {data.iconStyle && <span className="me-2">{data.iconStyle}</span>}
                                        <span className="sidebar-submenu-label">{t(data.title)}</span>
                                      </Link>
                                      <Collapse in={state.activeSubmenu === data.title ? true : false}>
                                        <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`}>
                                          {data.content && data.content.map((data, index) => {
                                            return (
                                              <li key={index}>
                                                <Link
                                                  className={`${path === getMenuPathKey(data.to) ? "mm-active" : ""}`}
                                                  to={resolveEventScopedPath(data.to)}
                                                  onClick={handleMenuLinkClick}
                                                >
                                                  {data.iconStyle && <span className="me-2">{data.iconStyle}</span>}
                                                  <span className="sidebar-submenu-label">{t(data.title)}</span>
                                                </Link>
                                              </li>
                                            )
                                          })}
                                        </ul>
                                      </Collapse>
                                    </>
                                    :
                                    <Link to={resolveEventScopedPath(data.to)}
                                      className={`${getMenuPathKey(data.to) === path ? 'mm-active' : ''}`}
                                      onClick={handleMenuLinkClick}
                                    >
                                      {data.iconStyle && <span className="me-2">{data.iconStyle}</span>}
                                      <span className="sidebar-submenu-label">{t(data.title)}</span>
                                    </Link>
                                  }

                                </li>

                              )
                            })}
                          </ul>
                        </Collapse>
                      </>
                      :
                      <Link
                        to={resolveEventScopedPath(data.to)}
                        className={`${menuPathKey === path ? 'mm-active' : ''}`}
                        onClick={handleMenuLinkClick}
                      >
                        {data.iconStyle}{" "}
                        <span className="nav-text">
                          <span className="sidebar-menu-label">{t(data.title)}</span>
                          {data.update && <span className="badge badge-xs style-1 badge-danger ms-2 sidebar-badge">{data.update}</span>}
                          {data.to === 'messages' && unreadCount > 0 && (
                            <span className="badge badge-xs style-1 badge-danger ms-2 sidebar-badge">{unreadCount}</span>
                          )}
                        </span>
                      </Link>
                    }
                  </li>
                )
              }
            })}
          </ul>
          {/*
            <div className="plus-box">
              <p className="fs-16 font-w500 mb-3">Ticket Sales Weekly Report</p>
              <Link className="text-white fs-14" to="/analytics">Learn more</Link>
            </div>
            */}
          <div className="copyright">
            <p>
              <strong className="sidebar-footer-brand">{branding.shortName}</strong>{" "}
              <span className="sidebar-footer-copyright">© {date.getFullYear()} All Rights Reserved</span>
            </p>
          </div>
        </div>

      </div>
    </>
  );

}

export default SideBar;
